<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->
          <div style="">
              <v-card
                flat
                class="mt-2"
                color="transparent">
                <div
                  class="d-flex align-center px-3">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
    
                    <span
                      class="fs-16 black--text ml-2"
                      style="font-weight: 600;">
                      Laba Rugi
                    </span>
                  </div>
    
                  <v-spacer />
    
                </div>
              </v-card>
              
              <div class="d-flex mt-3 px-4">
                <!-- <div>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="filter.date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.date"
                        :color="set_color"
                        placeholder="Pilihan periode"
                        prepend-inner-icon="mdi-calendar"
                        hide-details
                        readonly
                        filled
                        rounded
                        clearable
                        dense
                        v-bind="attrs"
                        v-on="on"
                        style="border-radius: 10px;"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.date"
                      no-title
                      scrollable
                      type="month"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu2 = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(filter.date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div> -->
                <div class="d-flex align-center" style="">
                  <!-- <v-select
                    filled
                    rounded
                    dense
                    hide-details
    
                    :color="set_color"
                    placeholder="Contoh. 2023"
    
                    :items="years"
                    :item-color="set_color"
                    class="fs-12 little-placeholder"
    
                    v-model="filter.year"
                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                  </v-select> -->
                  <div>
        
                    <v-menu
                      ref="range"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="picker.month">
                      <template v-slot:activator="{ on, attrs }">
                        <!-- <v-text-field
                          readonly
                          filled
                          rounded
                          dense
                          single-line
                          :color="set_color"
                          placeholder="Contoh. 2023-01-01 s/d 2023-12-01"
    
                          hide-details
    
                          v-on="on"
                          v-bind="attrs"
    
                          v-model="date_range"
                          class="mb-2"
                          style="border-radius: 10px !important;">
                        </v-text-field> -->
    
                        <v-card
                          v-on="on"
                          v-bind="attrs"
    
                          flat
                          color="#f2f2f2"
                          class="mb-0"
                          style="border-radius: 6px; width: 150px; min-width: 150px; max-width: 150px;">
                          <div
                            class="d-flex align-center"
                            style="padding: 9px;">
                            <!-- <v-icon>mdi-calendar-multiselect-outline</v-icon> -->
    
                            <div
                              class="fs-13 ml-1">
                              <!-- {{ filter.dates[0] | date_month }} - {{ filter.dates[1] | fulldate }} -->
                              {{ filter.month | month_year }}
                            </div>
                          </div>
                        </v-card>
                      </template>
                      
                      <v-date-picker 
                        type="month"
                        :color="set_color"
                        v-model="filter.month"
                        @input="picker.month = filter.month.length > 1 ? false : true; fetch();">
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <div class="ml-2">
                    <v-select
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih salah satu"
                      @input="fetch()"

                      hide-details
                      class="fs-12"
                      :items="position"

                      v-model="filter.position"
                      style="border-radius: 6px; width: 150px; min-width: 150px; max-width: 150px;">
                    </v-select>
                  </div>
                  <div class="ml-3" v-if="hak_akses.action.export">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="exports()"
                          :loading="process.export"
                          elevation="0"
                          dark
                          min-height="38"
                          small
                          min-width="38"
                          color="#b40c1d"
                          class="text-capitalize px-0 white--text"
                          style="border-radius: 6px;"
                          v-bind="attrs"
                          v-on="on">
                          <v-icon size="28">mdi-file-pdf-box</v-icon>
                        </v-btn>
                      </template>

                      <span>
                        Export Pdf
                      </span>
                    </v-tooltip>
                  </div>
                  <div class="ml-3" v-if="hak_akses.action.export">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="exports_excel()"
                          :loading="process.export_excel"
                          elevation="0"
                          dark
                          min-height="38"
                          small
                          min-width="38"
                          color="#097640"
                          class="text-capitalize px-0 white--text"
                          style="border-radius: 6px;"
                          v-bind="attrs"
                          v-on="on">
                          <v-icon size="28">mdi-microsoft-excel</v-icon>
                        </v-btn>
                      </template>

                      <span>
                        Export Excel
                      </span>
                    </v-tooltip>
                  </div>
                  <div class="ml-auto d-flex">
                    <v-card flat style="border-radius: 6px; background-color: #455A64;" class="ml-4">
                      <v-card-text class="py-2">
                        <div class="white--text pb-0">
                          <div class="d-flex">
                            <div class="fs-12 font_weight_600">
                              Laba Rugi
                            </div>
                            <div class="fs-12 font-weight-bold ml-2">
                              : <span v-if="filter.position === 'Internal'">{{ laba_rugi | price }} </span> <span v-if="filter.position === 'Public'">{{ laba_rugi_public | price }} </span>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card flat style="border-radius: 6px; background-color: #4CAF50;" class="mx-4">
                      <v-card-text class="py-2">
                        <div class="white--text pb-0">
                          <div class="d-flex">
                            <div class="fs-12 font_weight_600">
                              Total Pendapatan
                            </div>
                            <div class="fs-12 font-weight-bold ml-2">
                              : <span v-if="filter.position === 'Internal'">{{ total_pendapatan | price }} </span> <span v-if="filter.position === 'Public'">{{ total_pendapatan_public | price }} </span>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card flat style="border-radius: 6px; background-color: #D81B60;" class="">
                      <v-card-text class="py-2">
                        <div class="white--text pb-0">
                          <div class="d-flex">
                            <div class="fs-12 font_weight_600">
                              Total Biaya: 
                            </div>
                            <div class="fs-12 font-weight-bold ml-2">
                              : <span v-if="filter.position === 'Internal'">{{ total_biaya | price }} </span> <span v-if="filter.position === 'Public'">{{ total_biaya_public | price }} </span>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                    <!-- <div>
                      <div style="" class="text-right px-4 pl-2 d-flex align-center">
                        <div class="black_one font_weight_600 fs-12">
                          Laba Rugi: 
                        </div>
                        <div class="font_weight_600 fs-15 ml-2" :class="'black_one'">
                          {{ laba_rugi | price }}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div style="" class="text-right px-4 pl-2 d-flex align-center">
                        <div class="black_one fs-12 font_weight_600">
                          Total Pendapatan: 
                        </div>
                        <div class="font_weight_600 fs-15 ml-2" :class="'black_one'">
                          {{ total_pendapatan | price }}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div style="" class="text-right px-4 pl-2 d-flex align-center">
                        <div class="black_one font_weight_600 fs-12">
                          Total Biaya: 
                        </div>
                        <div class="font_weight_600 fs-15 ml-2" :class="'black_one'">
                          {{ total_biaya | price }}
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <v-row
                class="pa-4 py-0 mt-1">
                <v-col 
                  cols="12"
                  class="py-0">
                  <v-card 
                    flat
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">
                      <v-card-text
                        v-if="process.load" 
                        class="pb-0 my-4" 
                        style="height: calc(100vh - 250px); width: 800px; display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <div class="mb-4 title">
                            Mohon Tunggu . . .
                          </div>
    
                          <v-progress-linear
                            :color="set_color"
                            indeterminate
                            rounded
                            height="10">
                          </v-progress-linear>
                        </div>
                      </v-card-text>
    
                      <div v-if="!process.load">
                        <v-card-text class="px-0 pt-0">
                          <div class="d-flex align-center mt-0 px-5" style="border-bottom: 1px solid #eee;" :style="`background-color: ${set_color};`">
                            <div style="min-width: 131px; width: 131px" class="fs-12 font_weight_600 white--text py-2">
                              No. Akun
                            </div>
                            <div style="min-width: 500px; width: 500px; padding-left: 30px;" class="py-2 fs-12 font_weight_600 white--text">
                              Nama Akun
                            </div>
                            <div class="ml-auto py-2 fs-12 font_weight_600 white--text pr-0 text-right" style="width: 300px; max-width: 300px; min-width: 300px;">
                              Saldo
                            </div>
                            <div class="ml-auto py-2 fs-12 font_weight_600 white--text pr-0 text-right" style="width: 100%">
                              
                            </div>
                          </div>
                          <div style="height: calc(100vh - 240px); overflow-y: auto; padding-right: 8px; width: fit-content">
    
                            <div class="fs-14 pb-2 pt-2 black_one font_weight_600 px-5 pr-2" style="position: sticky; top: 0; background: #fff; z-index: 1;">
                              <div class="d-flex align-center">
                                <div>
                                  Pendapatan
                                </div>
                                <div class="ml-auto">
                                  <!-- {{ total_pendapatan | price }} -->
                                  <span v-if="filter.position === 'Public'">
                                    {{ total_pendapatan_public | price }}
                                  </span>
                                  <span v-if="filter.position === 'Internal'">
                                    {{ total_pendapatan | price }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <v-treeview
                              :items="list_pendapatan"
                              item-key="id"
                              activatable
                              open-all

                              item-children="child"
                              item-text="test"
                              class="border_buttom_tree fs-12"
                            >
                              <template v-slot:prepend="{ item }">
                                <!-- <v-icon v-if="item.child">
                                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                </v-icon>
                                <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                                <div class="d-flex">
                                  <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                    {{ item.number }}
                                  </div>
                                </div>
        
                                <!-- <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      min-width="24"
                                      min-height="24"
                                      x-small
                                      rounded
                                      @click="dialog.status = true; reset(item);"
                                      color="orange"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="12">mdi-file-cancel</v-icon>
                                      
                                    </v-btn>
                                  </template>
          
                                  <span>Nonaktifkan</span>
                                </v-tooltip> -->
        

                              </template>
                              <!-- <template v-slot:label="{item}">
                                <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                              </template> -->
                              <template v-slot:append="{ item }">
                                <div class="d-flex">
                                  <div style="min-width: 500px; padding-left: 30px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.name }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 300px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    <span v-if="filter.position === 'Public'">
                                      {{ item.saldo_public | price }}
                                    </span>
                                    <span v-if="filter.position === 'Internal'">
                                      {{ item.saldo | price }}
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </v-treeview>
    
                            <div class="fs-14 pb-2 pt-2 black_one font_weight_600 px-5 pr-2" style="border-top: 1px solid #eee; position: sticky; top: 0; background: #fff; z-index: 1;">
                              <div class="d-flex align-center">
                                <div>
                                  Biaya
                                </div>
                                <div class="ml-auto">
                                  <!-- {{ total_biaya | price }} -->
                                  <span v-if="filter.position === 'Public'">
                                    {{ total_biaya_public | price }}
                                  </span>
                                  <span v-if="filter.position === 'Internal'">
                                    {{ total_biaya | price }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            
                            <v-treeview
                              :items="list_biaya"
                              item-key="id"
                              activatable
                              open-all

                              item-children="child"
                              item-text="test"
                              class="border_buttom_tree fs-12"
                            >
                              <template v-slot:prepend="{ item }">
                                <!-- <v-icon v-if="item.child">
                                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                </v-icon>
                                <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                                <div class="d-flex">
                                  <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                    {{ item.number }}
                                  </div>
                                </div>
        
                                <!-- <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      min-width="24"
                                      min-height="24"
                                      x-small
                                      rounded
                                      @click="dialog.status = true; reset(item);"
                                      color="orange"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="12">mdi-file-cancel</v-icon>
                                      
                                    </v-btn>
                                  </template>
          
                                  <span>Nonaktifkan</span>
                                </v-tooltip> -->
        

                              </template>
                              <!-- <template v-slot:label="{item}">
                                <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                              </template> -->
                              <template v-slot:append="{ item }">
                                <div class="d-flex">
                                  <div style="min-width: 500px; padding-left: 30px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.name }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 300px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    <!-- {{ item.saldo | price }} -->
                                    <span v-if="filter.position === 'Public'">
                                      {{ item.saldo_public | price }}
                                    </span>
                                    <span v-if="filter.position === 'Internal'">
                                      {{ item.saldo | price }}
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </v-treeview>
                          </div>
                        </v-card-text>
                        <v-card-text
                          v-if="list_pendapatan.length === 0 && list_biaya.length === 0"
                          class="pb-0 my-4" style="height: calc( 100vh - 250px ); display: flex; align-items: center; justify-content: center;">
                          <div class="text-center">
                            <v-img 
                              class="mx-auto"
                              contain
                              alt="vuetify"
                              :width="90"
                              :height="90"
                              :src="require('@/assets/image/empty.png')">
                              <!-- <template v-slot:placeholder>
                                <v-row
                                  class=" "
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template> -->
                            </v-img>
                            <div class="mt-3 fs-16">
                              Belum Ada Laba Rugi
                            </div>
                          </div>
                        </v-card-text>
                    
                      </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        selected_data: '',
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
        },
        laba_rugi: 0,
        
        search: '',
        picker: {
          range: false,

          start_date: false,
          end_date: false,
          month: false
        },

        menu2: false,
        filter: {
          date: '',
          year: new Date().getFullYear(),

          month: moment().format('YYYY-MM'),
          month_text: 'Januari',
          position: 'Internal'
        },

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          activa: '',
          biaya: ''
        },
        position: ['Internal', 'Public'],

        role: [],

        options: {},
        headers: [],
        list: [],
        list_pendapatan: [],
        list_biaya: [],
        pagination: {},
        total_pendapatan: 0,
        total_biaya: 0,
        total_pendapatan_public: 0,
        total_biaya_public: 0,
        laba_rugi_public: 0,

        lastIndex: 0,
        limit: 20,

        form: {
          month: moment().format('YYYY-MM'),
          position: '',
          biaya_array: [],
          pendapatan_array: []
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false,
          export: false,
          export_excel: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'filter.year': function () {
        this.fetch()
      },

      'filter.month': function () {
        let t = this

        let m = this.months.filter(function(v) {
          return t.filter.month == v.value
        })

        if (m.length > 0) {
          this.filter.month_text = m[0].text
        }
        this.fetch()
      },
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 3) {
            menu = item
          }
        })
        return menu
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      years () {
        let max = new Date().getFullYear()+4, min = max - 8, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          // limit: pagination.row,
          // page: pagination.page,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          // search: this.search
          position: (this.filter.position).toLowerCase(),
          month: this.filter.month
        }

        this.selected.row = []

        await get(`lostprofit/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list_pendapatan = []
          this.list_biaya = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              // {
              //   text: 'Aksi',
              //   width: '120px',
              //   value: 'id',
              //   freeze: true,
              //   hide: false,
              //   align: 'center',
              //   format: 'action'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama',
                width: '100%',
                value: 'name',
                freeze: false,
                hide: false
              }
            ]
            this.list_pendapatan = res.results.data.pendapatan_array
            this.list_biaya = res.results.data.biaya_array
            this.total_pendapatan = res.results.data.total_pendapatan*1
            this.total_biaya = res.results.data.total_biaya*1
            this.laba_rugi = res.results.data.laba_rugi*1
            this.total_pendapatan_public = res.results.data.total_pendapatan_public*1
            this.total_biaya_public = res.results.data.total_biaya_public*1
            this.laba_rugi_public = res.results.data.laba_rugi_public*1
            // this.list.map((item, index) => {
            //   this.total_pendapatan += (item.balance*1)
            // })

            // this.list_biaya.map((item, index) => {
            //   this.total_biaya += (item.balance*1)
            // })

            // this.list = res.results.data
            // this.pagination = res.results.pagination


            // this.lastIndex = (pagination.page - 1) * pagination.row 
            // this.lastIndex += 1

            // this.addFreezes()

            // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper-laba-rugi') })

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      // closeForm() {
      //   this.form.biaya_array = []
      //   this.form.pendapatan_array = []
      //   this.list_pendapatan.map((item, index) => {
      //     this.form.pendapatan_array.push(item)
      //   })

      //   this.list_biaya.map((item, index) => {
      //     this.form.biaya_array.push(item)
      //   })
      // },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        this.form.month = moment().format('YYYY-MM')
        this.form.position = ''
        this.message.error = ''
        this.form.biaya_array = []
        this.form.pendapatan_array = []
        this.list_pendapatan.map((item, index) => {
          this.form.pendapatan_array.push(item)
        })

        this.list_biaya.map((item, index) => {
          this.form.biaya_array.push(item)
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = 'neraca/initial/add'

          // SAVE TO REST API
          await post(url, {
            data: {
              month: this.form.month,
              position: this.form.position,
              biaya_array: this.form.biaya_array,
              pendapatan_array: this.form.pendapatan_array
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // if (this.form.id === '') {
              //   this.fetch()
              // } else {
              //   this.fetch(this.paginationList)
              // }
              this.fetchData()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/satuan/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          // limit: this.pagination.row,
          // page: this.pagination.page,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          // search: this.search,
          position: (this.filter.position).toLowerCase(),
          month: this.filter.month
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/lostprofit/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports_excel () {
        this.message.error = ''

        this.process.export_excel = true

        let params = {
          month: this.filter.month,
          position: (this.filter.position).toLowerCase()
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/lostprofit/export_excel`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_excel = false
          // console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper-laba-rugi { 
  overflow-y: auto; 
  height: calc(100vh - 260px); 
} 
.wrapper-laba-rugi th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
.list_hover:hover {background-color: #1976d236;}
.selected {background-color: #1976d236;}

</style>